import React from "react"
import SVG from "react-inlinesvg";
import {NavLink}  from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux"
import { toAbsoluteUrl } from "../../../../../../../../_metronic/_helpers";
import {formatDate, permissionCssClass} from "../../../../../../../util/Helpers"; 
import { Permissions, PermissionType } from "../../../../../../../util/Permissions";

const Compliance = props => {

    const adminUser = useSelector( ({auth}) => (auth.user), shallowEqual);
    const profileData = useSelector(({selectedUser}) => selectedUser.data.profile, shallowEqual);

    // {/* <!--begin::Row--> */}
    return <div>
                <div className="row">
                    <div className="col-lg-6">

                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="card-header border-0">
                                <h3 className="card-title font-weight-bolder text-dark">Disclosure</h3>
                                <div className={`card-toolbar ${permissionCssClass(adminUser, Permissions.PROFILE, PermissionType.UPDATE)}`}>
                                    <div className="dropdown dropdown-inline">
                                        <button
                                            disabled={true}
                                            className="btn btn-icon btn-default border btn-bg-white btn-hover-light-primary btn-sm mr-n4"
                                            
                                            >
                                            <span className="svg-icon svg-icon-md svg-icon-primary">
                                                <SVG
                                                title="Edit Basic Details"
                                                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                />
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mb-10">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Terms of Use</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.disclosuresData?.termsOfUse ? "True" : "False"}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Customer Agreement</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.disclosuresData?.customerAgreement ? "True" : "False"}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">IRA Agreement</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.disclosuresData?.iraAgreement ? "True" : "False"}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Market Data Agreement</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.disclosuresData?.marketDataAgreement ? "True" : "False"}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Margin Agreement</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.disclosuresData?.marginAgreement ? "True" : "False"}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Account Agreement</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.disclosuresData?.accountAgreement ? "True" : "False"}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Rule 14b</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.disclosuresData?.rule14b ? "True" : "False"}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Privacy Policy</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.disclosuresData?.privacyPolicy ? "True" : "False"}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Data Sharing</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.disclosuresData?.dataSharing ? "True" : "False"}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">IP Address</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.disclosuresData?.ipAddress}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Signed By</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.disclosuresData?.signedBy}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Date</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{formatDate(profileData.disclosuresData?.date)}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}
                        
                    
                    </div>
                    <div className="col-lg-6">
                        
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="card-header border-0">
                                <h3 className="card-title font-weight-bolder text-dark">Investment Profile</h3>
                                <div className={`card-toolbar ${permissionCssClass(adminUser, Permissions.PROFILE, PermissionType.UPDATE)}`}>
                                    <div className="dropdown dropdown-inline">
                                        <NavLink to={`/users/edit/${props.match.params.userId}?tab=3`}
                                            title="Edit Basic Details"
                                            className="btn btn-icon btn-default border btn-bg-white btn-hover-light-primary btn-sm mr-n4"
                                            
                                            >
                                            <span className="svg-icon svg-icon-md svg-icon-primary">
                                                <SVG
                                                title="Edit Basic Details"
                                                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                />
                                            </span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mb-10">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Approximate annual income </span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">${(profileData.investmentData?.annualIncome?.toLocaleString()) ?? 0}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Liquid net worth</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">${(profileData.investmentData?.networthLiquid?.toLocaleString()) ?? 0}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Total net worth</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">${(profileData.investmentData?.networthTotal?.toLocaleString()) ?? 0}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Investment objectives</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.investmentData?.investmentObjectives}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Investment experience</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.investmentData?.investmentExperience}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Risk tolerance</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.investmentData?.riskTolerance}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">User's tax rate</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.investmentData?.taxRate}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}
                        
                        {/* <!--begin::List Widget 14--> */}
                        <div className="card card-custom gutter-b">
                            {/* <!--begin::Header--> */}
                            <div className="card-header border-0">
                                <h3 className="card-title font-weight-bolder text-dark">Compliance & AML</h3>
                                <div className={`card-toolbar ${permissionCssClass(adminUser, PermissionType.PROFILE, PermissionType.UPDATE)}`}>
                                    <div className="dropdown dropdown-inline">
                                        <NavLink to={`/users/edit/${props.match.params.userId}?tab=3`}
                                            title="Edit Basic Details"
                                            className="btn btn-icon btn-default border btn-bg-white btn-hover-light-primary btn-sm mr-n4"
                                            
                                            >
                                            <span className="svg-icon svg-icon-md svg-icon-primary">
                                                <SVG
                                                title="Edit Basic Details"
                                                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                />
                                            </span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                            {/* <!--end::Header--> */}
                            {/* <!--begin::Body--> */}
                            <div className="card-body pt-2">
                                {/* <!--begin::Item--> */}
                                <div className="d-flex flex-column mb-10">
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Funding sources for account</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.complianceData?.fundingSources?.join(", ")}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Expected transfers per month count</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.complianceData?.transferFrequencyPerMonth}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Expected annual monetary transfer total</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.complianceData?.transferTotalExpected}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                    {/* <!--begin::Field--> */}
                                    <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                        <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Past 12 months investment count</span>
                                        <span className="text-muted font-weight-bold font-size-sm my-1">{profileData.complianceData?.investmentHistory12M}</span>
                                    </div>
                                    {/* <!--end::Field--> */}
                                </div>
                                {/* <!--end::Item--> */}
                                
                            </div>
                            {/* <!--end::Body--> */}
                        </div>
                        {/* <!--end::List Widget 14--> */}
                        
                    </div>
                </div>
                {/* <!--end::Row--> */}
            </div>

}

export default Compliance;